// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-2",
    "aws_cognito_identity_pool_id": "ap-northeast-2:0f46b058-4963-4431-8597-16361262a71c",
    "aws_cognito_region": "ap-northeast-2",
    "aws_user_pools_id": "ap-northeast-2_SVStKVyAb",
    "aws_user_pools_web_client_id": "5cbpfml6nddm6kqre7ej6ld4q3",
    "oauth": {},
    "aws_content_delivery_bucket": "myvaletres20190826-20190826163231-hostingbucket-masterenv",
    "aws_content_delivery_bucket_region": "ap-northeast-2",
    "aws_content_delivery_url": "https://d3lcsuzyjdewe3.cloudfront.net",
    "aws_mobile_analytics_app_id": "381f153e6d8942d2b090894912eba8b3",
    "aws_mobile_analytics_app_region": "us-west-2"
};


export default awsmobile;
